import { useState } from 'react';
import { authAPI } from '../api';

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await authAPI.login(username.trim().toLowerCase(), password);
      const { token, user } = res.data;
      localStorage.setItem('wh_token', token);
      localStorage.setItem('wh_user', JSON.stringify(user));
      onLogin(user);
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Check credentials.');
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg,#0f172a 0%,#1e3a5f 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16
    }}>
      <div style={{
        background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255,255,255,0.1)', borderRadius: 20,
        padding: '40px 28px', width: '100%', maxWidth: 360
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            width: 64, height: 64, borderRadius: 16, margin: '0 auto 14px',
            background: 'linear-gradient(135deg,#3b82f6,#06b6d4)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28
          }}>📦</div>
          <h1 style={{ color: '#fff', fontSize: 22, fontWeight: 700, margin: 0 }}>WarehouseScan</h1>
          <p style={{ color: '#64748b', fontSize: 14, margin: '6px 0 0' }}>Sign in to continue</p>
        </div>

        <form onSubmit={handleLogin}>
          <label style={{ color: '#94a3b8', fontSize: 13, display: 'block', marginBottom: 6 }}>Username</label>
          <input
            value={username} onChange={e => setUsername(e.target.value)}
            placeholder="e.g. worker1" autoCapitalize="none" autoCorrect="off" required
            style={{
              width: '100%', padding: '12px 14px', borderRadius: 10, marginBottom: 14,
              background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)',
              color: '#fff', fontSize: 16, outline: 'none', boxSizing: 'border-box'
            }}
          />
          <label style={{ color: '#94a3b8', fontSize: 13, display: 'block', marginBottom: 6 }}>Password</label>
          <input
            type="password" value={password} onChange={e => setPassword(e.target.value)}
            placeholder="Enter password" required
            style={{
              width: '100%', padding: '12px 14px', borderRadius: 10, marginBottom: 20,
              background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)',
              color: '#fff', fontSize: 16, outline: 'none', boxSizing: 'border-box'
            }}
          />
          {error && (
            <div style={{
              background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.4)',
              color: '#fca5a5', borderRadius: 9, padding: '10px 14px', fontSize: 14,
              marginBottom: 14, textAlign: 'center'
            }}>{error}</div>
          )}
          <button type="submit" disabled={loading} style={{
            width: '100%', padding: 14, borderRadius: 10, border: 'none',
            background: loading ? '#334155' : 'linear-gradient(135deg,#3b82f6,#06b6d4)',
            color: '#fff', fontSize: 16, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer'
          }}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <div style={{
          marginTop: 22, padding: '12px 14px',
          background: 'rgba(255,255,255,0.03)', borderRadius: 10,
          fontSize: 12, color: '#475569', lineHeight: 1.8
        }}>
          <strong style={{ color: '#64748b' }}>Demo logins:</strong><br />
          worker1 / worker123 &nbsp;·&nbsp; qc1 / qc123<br />
          inv1 / inv123 &nbsp;·&nbsp; ekart / ekart123<br />
          admin / admin123
        </div>
      </div>
    </div>
  );
}
